const initHeader = () => {
  const header = document.querySelector('.header');

  if (!header) {
    return;
  }

  let prevScrollYPos = 0; // in px
  const hidePos = 200; // in px

  const handleScroll = () => {
    const scrollY = window.scrollY;

    if (scrollY === 0) {
      header.classList.remove('hide');
    } else if (scrollY > hidePos) {
      if (scrollY < prevScrollYPos) {
        header.classList.remove('hide');
      } else {
        header.classList.add('hide');
      }
    }

    prevScrollYPos = scrollY;
  };

  if (header.classList.contains('header--without-nav')) {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
  } else if (window.innerWidth <= 1100) {
    header.classList.add('header--sticky');
    handleScroll();
    window.addEventListener('scroll', handleScroll);
  } else {
    const nav = document.querySelector('.header .nav');

    header.classList.remove('header--sticky');

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          nav.classList.remove('nav--scrolled');
        } else {
          nav.classList.add('nav--scrolled');
        }
      });
    };

    const createObserver = (boxElement) => {
      let observer;

      let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };

      observer = new IntersectionObserver(handleIntersection, options);
      observer.observe(boxElement);
    };

    window.addEventListener(
      'load',
      () => {
        const header = document.querySelector('.header');

        createObserver(header);
      },
      false
    );
  }
};

export {initHeader};
